<template>
  <div class="col-12" style="padding: 0px">
    <div class="card" style="padding: 0px">
      <div class="card-header">
        <h5>
          الموافق عليها <button class="btn btn-sm btn-success" @click="excel()" title="export to excel" style="padding: 5px"><i class="fa fa-download"></i></button>
          &nbsp; 
          <button class="btn btn-sm btn-primary" @click="download()" title="تحميل صور المشرفين" style="padding: 5px"><i class="fa fa-image"></i> <i class="fa fa-download"></i></button>
          &nbsp;
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="checkbox" v-model="archived" @change="getList()"> عرض المؤرشفين
            </label>
          </div>
        </h5>
      </div>
      <div class="card-body" style="padding: 0px">
        <div class="col-12 table-responsive"  style="padding: 0px">
          <table class="table table-hover table-bordered table-sm table-striped" style="padding: 0px">
            <thead>
              <th>
                م
              </th>
              <th>
                رقم العقد
              </th>
              <th>
                الاسم
              </th>
              <th>
                الجوال
              </th>
              <th>
                تاريخ الاجابة
              </th>
              <th>
                خيارات
              </th>
            </thead>
            <tbody>
              <tr v-for="(form, i) in list" :key="form._id">
                <td>
                  {{ i+1 }}
                </td>
                <td>
                  {{ form.id }}
                </td>
                <td>
                  {{ form.name }}
                </td>
                <td>
                  {{ form.phone }}
                </td>
                <td>
                  {{ form.end_date }}
                </td>
                <td>
                  <button style="border-radius: 0px; border:none" class="btn-sm btn btn-primary"  @click="current = form; header = current.info.contract.header; body = current.info.contract.body; footer = current.info.contract.footer;" v-b-modal.contract>
                    <i class="fa fa-edit"></i> العقد
                  </button>
                  <button style="border-radius: 0px; border: none; padding: 5px" class="btn-sm btn btn-success" v-if="form.signature">
                    <i class="fa fa-check"></i>
                    تم التوقيع
                  </button>
                  <button style="border-radius: 0px; border: none; padding: 5px" class="btn-sm btn btn-info" @click="current = form;" v-b-modal.details>
                    <i class="fa fa-list"></i>
                     التفاصيل
                  </button>
                  <button style="border-radius: 0px; border: none; padding: 5px" class="btn-sm btn btn-secondary" v-if="!form.archived" @click="archive(form._id)">
                    <i class="fa fa-archive"></i>
                     ارشفة
                  </button>
                  <button style="border-radius: 0px; border: none; padding: 5px" class="btn-sm btn btn-secondary" v-if="form.archived" @click="dearchive(form._id)">
                    <i class="fa fa-archive"></i>
                    الغاء
                     الارشفة
                  </button>
                  <button style="border-radius: 0px; border: none; padding: 5px" class="btn-sm btn btn-danger" v-if="archived" @click="deleteadmin(form._id)">
                    <i class="fa fa-trash"></i>
                    حذف
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <b-modal id="details" title="التفاصيل" hide-footer size="lg">
      <h5>
         البيانات
      </h5>
      <div class="col-12 table-responsive" v-if="current.content">
        <table class="table table-hover table-bordered table-striped table-sm">
          <tbody>
            <tr v-for="(a,b) in current.content" :key="a">
              <td>
                {{ b
                .replace("national", "الجنسية")
                .replace("name", "الاسم")
                .replace("phone", "الجوال")
                .replace("number_source", "مصدر الهوية")
                .replace("email", "الايميل")
                .replace("number", "الهوية")
                .replace("birth_date", "تاريخ الميلاد")
                .replace("gender", "الجنس")
                .replace("file_1", "صورة من الهوية")
                .replace("file_2", "شهادة الآيبان")
                .replace("file_3", "الصورة الشخصية")
                .replace("bank_number", "رقم الحساب")
                .replace("bank", "البنك")
                .replace("work_before", "هل سبق العمل")
                .replace("hij_before", "هل سبق الحج")
                .replace("last_degree", "آخر مؤهل")
                .replace("about", "عن نفسك")
                .replace("file_4", "صورة المؤهل")
                 }}
              </td>
              <td>
                <span v-if="!a.includes('usercontent')">{{ a.replace("yes", "نعم").replace("no", "لا").replace("man", 'ذكر').replace("woman", "أنثى") }}</span>
                <a :href="a" v-if="a.includes('usercontent')" target="_blank">عرض</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h5>
         الوظيفة
      </h5>
      <div class="col-12 table-responsive" v-if="current.job">
        <table class="table table-hover table-bordered table-striped table-sm">
          <tbody>
            <template v-for="(a,b) in current.job">
              <tr :key="a" v-if="b != 'code' && b != 'max'">
                <td>
                  {{ b
                  .replace("title", "العنوان")
                  .replace("salary", "الراتب")
                  .replace("extra", "المبلغ الاضافي")
                  .replace("rules", "المهام")
                  .replace("bouns", "المكافأة")
                  .replace("time", "فترة العمل")
                   }}
                </td>
                <td>
                  <span v-if="b != 'rules'">{{ a }}</span>
                  <textarea name="" v-if="b == 'rules'" readonly class="form-control" id="" rows="3">{{ a }}</textarea>
                </td>
              </tr>
              </template>
          </tbody>
        </table>
      </div>
    </b-modal>
    <b-modal id="contract" title="العقد" hide-footer size="xl">
     <ckeditor :editor="editor" dir="rtl" v-model="header" :config="editorConfig"></ckeditor>
     <br>
     <ckeditor :editor="editor" dir="rtl" v-model="body" :config="editorConfig"></ckeditor>
     <br>
     <ckeditor :editor="editor" dir="rtl" v-model="footer" :config="editorConfig"></ckeditor>
     <div class="col-12 text-center g">
      <button class="btn btn-success" @click="save()">
        <i class="fa fa-save"></i> حفظ التعديلات
      </button>
      &nbsp;
      <button class="btn btn-warning" @click="printContract()">
        <i class="fa fa-print"></i> طباعة
      </button>
     </div><br>
     <table class="table table-hover table-bordered table-sm">
      <tbody>
        <tr>
          <td>
            {section}
          </td>
          <td>
            القسم
          </td>
        </tr>
        <tr>
          <td>
            {job}
          </td>
          <td>
            الوظيفة
          </td>
        </tr>
        <tr>
          <td>
            {salary}
          </td>
          <td>
            الراتب
          </td>
        </tr>
        <tr>
          <td>
            {bouns}
          </td>
          <td>
            المكافأة
          </td>
        <tr>
          <td>
            {extra}
          </td>
          <td>
            المبلغ الاضافي
          </td>
        </tr>
        <tr>
          <td>
            {rules}
          </td>
          <td>
            المهام
          </td>
        </tr>
      </tbody>
     </table>
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
var XLSX = require("xlsx");
import {  VBModal, BModal, BDropdown, BDropdownItem } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BDropdown,
    BDropdownItem,
    BModal
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
    data(){
        return {
            user: JSON.parse(localStorage.getItem("user")),
            list: [],
            archived: false,
            current: {},
            jobs: [],
            sections: [],
            header: "",
            body: "",
            footer: "",
            editor: ClassicEditor,
            editorData: '<p>Content of the editor.</p>',
            editorConfig: {
            language: {
                ui: 'ar',
                content: 'ar',
            }
            },
        }
    },
    created(){
        if(!checkPer('jobs')){
            this.$router.push('/pers')
            return;
        }
        this.getList()
        var g = this;
        $.post(api + '/admin/web/settings', {
            jwt: g.user.jwt
        }).then(function(r){
          g.jobs = (r.response.jobs ?? "").split(",")
          g.sections = (r.response.sections ?? "").split(",")
        })
    },
    methods: {
      deleteadmin(id){
        if(confirm("متأكد من حذف المشرف والعقد نهائيا؟")){
          var g = this;
          $.post(api + '/admin/forms/delete', {
              jwt: g.user.jwt,
              id: id
          }).then(function(r){
              g.getList()
          })
        }
      },
      download(id){
        if(confirm("متأكد من ضغط وتحميل صور المشرفين؟")){
          var g = this;
          alert("جاري الضغط...")
          $.post(api + '/admin/forms/download', {
              jwt: g.user.jwt
          }).then(function(r){
            alert(`<a href='${r.response}' target='_blank'>اضغط هنا للتحميل</a>`,100)
          })
        }
      },
      excel(){
          const wb = XLSX.utils.book_new(), g = this;
          const Heading = [
              [
                  "رقم العقد",
                  "الاسم",
                  "الجوال",
                  "الايميل",
                  "الجنسية",
                  "الهوية",
                  "مصدر الهوية",
                  "تاريخ الميلاد",
                  "الجنس",
                  "رقم الحساب",
                  "البنك",
                  "هل سبق العمل",
                  "هل سبق الحج",
                  "آخر مؤهل",
                  "عن نفسك",
                  "الوظيفة", 
                  "القسم", 
                  "الراتب", 
                  "الراتب على الوظائف الاضافية"
              ]
          ];
          var xx = [];
          var xxx = (xa)=>{
            if(!xa){
              xa = ""
            }
            xa = xa.toString()
            xa = xa.replace("yes", "نعم")
                .replace("nothing", "لا شيئ")
                .replace("no", "لا")
                .replace("woman", "أنثى")
                .replace("man", "ذكر")
            return xa;
          }
          g.list.forEach(function(a, i){
              var arr = [];
              arr.push(xxx(a.id))
              arr.push(xxx(a.content.name))
              arr.push(xxx(a.content.phone))
              arr.push(xxx(a.content.email))
              arr.push(xxx(a.content.national))
              arr.push(xxx(a.content.number))
              arr.push(xxx(a.content.number_source))
              arr.push(xxx(a.content.birth_date))
              arr.push(xxx(a.content.gender))
              arr.push(xxx(a.content.bank_number))
              arr.push(xxx(a.content.bank))
              arr.push(xxx(a.content.work_before))
              arr.push(xxx(a.content.hij_before))
              arr.push(xxx(a.content.last_degree))
              arr.push(xxx(a.content.about))
              arr.push(xxx(a?.job?.title))
              arr.push(xxx(a?.job?.section))
              arr.push(xxx(a?.job?.salary))
              arr.push(xxx(a?.tasks_salary))
              xx.push(arr)
          })
          
          // creating sheet and adding data from 2nd row of column A.
          // leaving first row to add Heading
          const ws = XLSX.utils.json_to_sheet(xx, { origin: 'A2', skipHeader: true });
              
          // adding heading to the first row of the created sheet.
          // sheet already have contents from above statement.
          XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
              
          // appending sheet with a name
          XLSX.utils.book_append_sheet(wb, ws, 'Records');
              
          const fileContent = XLSX.writeFile(wb, $("title").first().text().split("—") + ".xlsx");
      },
      printContract(){
        var g = this;
        var win = window.open("");
        win.document.write(`
        <html dir='rtl'>
          <head>
          <style>
              @page {
                  margin: 0;
              }
              h4{
                line-height: 1.8;
              }
              body{
                background-image: url("/images/contract.png") ;
                background-repeat:repeat-y;
                background-position: right top;
                background-attachment:fixed;
                background-size:100%;
              }
              .content{
                padding: 60px;
                padding-top: 130px;
                padding-bottom: 100px;}
                .page-break {
              page-break-before: always; /* Forces a new page with padding */
              padding-top: 130px; /* Ensures the top padding is repeated on new pages */
          }
            </style>
          </head>
          <body>
            <div class='content'>
            <span style='position: absolute; top: 5px; left: 10px'>رقم العقد: ${g.current.id}</span>
              <center><h2>عقد عمل موسمي لحج عام ١٤٤٧ هـ</h2></center>
              <p>${g.replaceVariables(g.current, g.header.replaceAll("\n", "<br>"))}</p>
              <p>السيد/ ${g.current.name} 
              &nbsp;&nbsp;
              &nbsp;&nbsp;
              &nbsp;&nbsp;
              &nbsp;&nbsp;
              الجنسية/ ${g.current.content.national}</p>
              <p style='padding: 5px; border-top: 0.5px solid #ddd; border-bottom: 0.5px solid #ddd;'>
                بموجب هوية رقم/ ${g.current.content.number}
                &nbsp;&nbsp;
                &nbsp;&nbsp;
                &nbsp;&nbsp;
                صادرة من/ ${g.current.content.number_source}
                &nbsp;&nbsp;
                &nbsp;&nbsp;
                &nbsp;&nbsp;
                وتاريخ الميلاد/ ${g.current.content.birth_date.replaceAll('-', '/')}
              </p>
              <p style='padding: 5px; padding-top: 0px; margin-top: -10px; border-bottom: 0.5px solid #ddd;'>
                رقم الجوال/ 
                &nbsp;&nbsp;
                &nbsp;&nbsp;${g.current.phone}
              </p>
              <p>${g.replaceVariables(g.current, g.body.replaceAll("\n", "<br>"))}</p>
              <div class='page-break'>
                <p>
                ${g.replaceVariables(g.current, g.footer.replaceAll("\n", "<br>"))}
                </p>
                <div style='display: inline-block; width: 49%'>
                  <p style='margin: 0px auto; text-align: center'>الطرف الأول</p>
                  <p style='margin: 0px auto; text-align: center'>عبدالله عبدالعزيز عبدالله الشلاش</p>
                  <p>التوقيع:</p>
                </div>
                <div style='display: inline-block; width: 49%'>
                  <p style='margin: 0px auto; text-align: center'>الطرف الثاني</p>
                  <p style='margin: 0px auto; text-align: center'>${g.current.name}</p>
                  <p>&nbsp;&nbsp;&nbsp;التوقيع: ${g.current.signature ? "<img width='250' src='"+g.current.signature+"'>" : ''}</p>
                </div>
              </div>
            </div>
          </body>
        </html>
        `)
        win.document.close()
        setTimeout(() => {
          win.print()
        }, 1000);
      },
      save(){
        var g = this;
        $.post(api + '/admin/forms/update-contract', {
            jwt: g.user.jwt,
            id: g.current._id,
            header: g.header,
            body: g.body,
            footer: g.footer
        }).then(function(r){
          alert("تم الحفظ بنجاح", 100)
        })
      },
      replaceVariables(current, input){
        for(var i=0; i<=20; i++){
          input = input.replace( /{(.*?)}/, function (x) {
          x = x.replace('{', '').replace('}', '')
          if(x == 'job'){
              if(current.job['code']){
                  return current.job['title'];
              }
          }
          if(current[x]){
            return current[x];
          }
          if(current.info[x]){
            return current.info[x];
          }
          if(current.content[x]){
            return current.content[x];
          }
          if(current.job[x]){
            return current.job[x];
          }
          return `${x}`;
        } )
        }
        return input
      },
      getList(){
        var g = this;
        $.post(api + '/admin/forms/accepted-list', {
            jwt: g.user.jwt,
            archived: g.archived
        }).then(function(r){
            g.list = r.response.map(function(x){ 
              if(x.content){x.content = JSON.parse(x.content)};
              if(x.info){x.info = JSON.parse(x.info)}else{
                x.info = {}
              };
              return x;});
        })
      },
      archive(id){
        var g = this;
        if(confirm("متأكد من الارشفة؟")){
          $.post(api + '/admin/forms/archive', {
              jwt: g.user.jwt,
              id: id
          }).then(function(r){
              g.getList()
          })
        }
      },
      dearchive(id){
        var g = this;
        if(confirm("متأكد من الغاء الارشفة؟")){
          $.post(api + '/admin/forms/de-archive', {
              jwt: g.user.jwt,
              id: id
          }).then(function(r){
              g.getList()
          })
        }
      },
    }
}
</script>

<style>

</style>